function PlanQ({ ...props }) {
	return (
		<g {...props} id="unit-q">
			<g id="furniture">
				<polyline
					points="821.24 636.62 821.24 639.48 815.58 639.48 815.58 636.62 821.24 636.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="290.35"
					y1="663.63"
					x2="473.14"
					y2="663.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.17"
					y1="620.65"
					x2="323.3"
					y2="620.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="631.77"
					x2="290.35"
					y2="638.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="642.77"
					x2="290.35"
					y2="649.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="653.77"
					x2="290.35"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="660.76"
					x2="297.17"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="301.29"
					y1="660.76"
					x2="308.17"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.29"
					y1="660.76"
					x2="319.17"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.3"
					y1="660.76"
					x2="330.17"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.3"
					y1="660.76"
					x2="341.18"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.3"
					y1="660.76"
					x2="352.18"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.3"
					y1="660.76"
					x2="363.18"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.3"
					y1="660.76"
					x2="374.18"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.31"
					y1="660.76"
					x2="385.18"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.31"
					y1="660.76"
					x2="396.19"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.31"
					y1="660.76"
					x2="407.19"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.31"
					y1="660.76"
					x2="418.19"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.32"
					y1="660.76"
					x2="429.19"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.31"
					y1="660.76"
					x2="440.19"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.32"
					y1="660.76"
					x2="451.2"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.32"
					y1="660.76"
					x2="462.19"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.32"
					y1="660.76"
					x2="473.14"
					y2="660.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="660.76"
					x2="473.14"
					y2="653.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.93"
					y1="563.35"
					x2="72.92"
					y2="563.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.97"
					y1="606.33"
					x2="118.84"
					y2="606.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.01"
					y1="606.33"
					x2="327.88"
					y2="606.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.93"
					y1="573.21"
					x2="366.93"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.93"
					y1="566.21"
					x2="364.8"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.89"
					y1="566.21"
					x2="354.01"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.89"
					y1="566.21"
					x2="343.01"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.88"
					y1="566.21"
					x2="332.01"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.88"
					y1="566.21"
					x2="321.01"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.88"
					y1="566.21"
					x2="310"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.88"
					y1="566.21"
					x2="299"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.88"
					y1="566.21"
					x2="288"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.87"
					y1="566.21"
					x2="277"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="272.87"
					y1="566.21"
					x2="266"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.87"
					y1="566.21"
					x2="254.99"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.87"
					y1="566.21"
					x2="243.99"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.87"
					y1="566.21"
					x2="232.99"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.86"
					y1="566.21"
					x2="221.99"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.86"
					y1="566.21"
					x2="210.99"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.86"
					y1="566.21"
					x2="199.98"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.86"
					y1="566.21"
					x2="188.98"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.86"
					y1="566.21"
					x2="177.98"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="173.85"
					y1="566.21"
					x2="166.98"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.85"
					y1="566.21"
					x2="155.98"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.85"
					y1="566.21"
					x2="144.97"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.85"
					y1="566.21"
					x2="133.97"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.85"
					y1="566.21"
					x2="122.97"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.84"
					y1="566.21"
					x2="111.97"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.84"
					y1="566.21"
					x2="100.97"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.84"
					y1="566.21"
					x2="89.96"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.84"
					y1="566.21"
					x2="78.96"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.05"
					y1="566.21"
					x2="72.92"
					y2="566.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.92"
					y1="566.21"
					x2="72.92"
					y2="573.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.92"
					y1="577.33"
					x2="72.92"
					y2="584.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="466.01 476.29 466.01 553.64 388.66 553.64 388.66 476.29 466.01 476.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="388.46 96.18 340.54 96.18 340.54 102.39 388.46 102.39 388.46 96.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="338.28 95.62 390.71 95.62 390.71 96.18 338.28 96.18 338.28 95.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="338.28"
					y1="95.62"
					x2="390.71"
					y2="95.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.71"
					y1="95.62"
					x2="390.71"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.71"
					y1="96.18"
					x2="338.28"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.28"
					y1="96.18"
					x2="338.28"
					y2="95.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.46"
					y1="102.39"
					x2="340.54"
					y2="102.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.54"
					y1="96.18"
					x2="388.46"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="393.53 102.39 388.46 102.39 388.46 96.18 393.53 96.18 393.53 102.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="393.53"
					y1="102.39"
					x2="388.46"
					y2="102.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.46"
					y1="102.39"
					x2="388.46"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.46"
					y1="96.18"
					x2="393.53"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.53"
					y1="96.18"
					x2="393.53"
					y2="102.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="335.46 96.18 340.54 96.18 340.54 102.39 335.46 102.39 335.46 96.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="335.46"
					y1="96.18"
					x2="340.54"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.54"
					y1="96.18"
					x2="340.54"
					y2="102.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.54"
					y1="102.39"
					x2="335.46"
					y2="102.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.46"
					y1="102.39"
					x2="335.46"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.46"
					y1="97.31"
					x2="340.54"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="395.79 101.82 393.53 101.82 393.53 96.18 390.71 96.18 390.71 95.62 395.79 95.62 395.79 101.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="395.79"
					y1="101.82"
					x2="393.53"
					y2="101.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.53"
					y1="101.82"
					x2="393.53"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.53"
					y1="96.18"
					x2="390.71"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.71"
					y1="96.18"
					x2="390.71"
					y2="95.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.71"
					y1="95.62"
					x2="395.79"
					y2="95.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.79"
					y1="95.62"
					x2="395.79"
					y2="101.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="333.21 95.62 338.28 95.62 338.28 96.18 335.46 96.18 335.46 101.82 333.21 101.82 333.21 95.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="333.21"
					y1="95.62"
					x2="338.28"
					y2="95.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.28"
					y1="95.62"
					x2="338.28"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.28"
					y1="96.18"
					x2="335.46"
					y2="96.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.46"
					y1="96.18"
					x2="335.46"
					y2="101.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.46"
					y1="101.82"
					x2="333.21"
					y2="101.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.21"
					y1="101.82"
					x2="333.21"
					y2="95.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="330.34 97.31 330.34 100.17 178.94 100.17 178.94 97.31 330.34 97.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="330.34"
					y1="97.31"
					x2="330.34"
					y2="100.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.34"
					y1="100.17"
					x2="178.94"
					y2="100.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.94"
					y1="100.17"
					x2="178.94"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.94"
					y1="97.31"
					x2="330.34"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="395.79 97.31 401.52 97.31 401.52 114.5 395.79 114.5 395.79 97.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="401.52"
					y1="97.31"
					x2="395.79"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.52"
					y1="114.5"
					x2="401.52"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.79"
					y1="114.5"
					x2="401.52"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.79"
					y1="97.31"
					x2="395.79"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="327.48 97.31 333.21 97.31 333.21 114.5 327.48 114.5 327.48 97.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="333.21"
					y1="97.31"
					x2="327.48"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.21"
					y1="114.5"
					x2="333.21"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.48"
					y1="114.5"
					x2="333.21"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.48"
					y1="97.31"
					x2="327.48"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="176.07 97.31 181.8 97.31 181.8 114.5 176.07 114.5 176.07 97.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="181.8"
					y1="97.31"
					x2="176.07"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.8"
					y1="114.5"
					x2="181.8"
					y2="97.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.07"
					y1="114.5"
					x2="181.8"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.07"
					y1="97.31"
					x2="176.07"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="818.55 178.48 770.63 178.48 770.63 184.69 818.55 184.69 818.55 178.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="768.38 177.92 820.81 177.92 820.81 178.48 768.38 178.48 768.38 177.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="768.38"
					y1="177.92"
					x2="820.81"
					y2="177.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.81"
					y1="177.92"
					x2="820.81"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.81"
					y1="178.48"
					x2="768.38"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.38"
					y1="178.48"
					x2="768.38"
					y2="177.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.55"
					y1="184.69"
					x2="770.63"
					y2="184.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.63"
					y1="178.48"
					x2="818.55"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="823.63 184.69 818.55 184.69 818.55 178.48 823.63 178.48 823.63 184.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="823.63"
					y1="184.69"
					x2="818.55"
					y2="184.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.55"
					y1="184.69"
					x2="818.55"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.55"
					y1="178.48"
					x2="823.63"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="178.48"
					x2="823.63"
					y2="184.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="765.56 178.48 770.63 178.48 770.63 184.69 765.56 184.69 765.56 178.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="765.56"
					y1="178.48"
					x2="770.63"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.63"
					y1="178.48"
					x2="770.63"
					y2="184.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.63"
					y1="184.69"
					x2="765.56"
					y2="184.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.56"
					y1="184.69"
					x2="765.56"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.55"
					y1="179.61"
					x2="770.63"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="825.88 184.12 823.63 184.12 823.63 178.48 820.81 178.48 820.81 177.92 825.88 177.92 825.88 184.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="825.88"
					y1="184.12"
					x2="823.63"
					y2="184.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="184.12"
					x2="823.63"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.63"
					y1="178.48"
					x2="820.81"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.81"
					y1="178.48"
					x2="820.81"
					y2="177.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.81"
					y1="177.92"
					x2="825.88"
					y2="177.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.88"
					y1="177.92"
					x2="825.88"
					y2="184.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="763.3 177.92 768.38 177.92 768.38 178.48 765.56 178.48 765.56 184.12 763.3 184.12 763.3 177.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="763.3"
					y1="177.92"
					x2="768.38"
					y2="177.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.38"
					y1="177.92"
					x2="768.38"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.38"
					y1="178.48"
					x2="765.56"
					y2="178.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.56"
					y1="178.48"
					x2="765.56"
					y2="184.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.56"
					y1="184.12"
					x2="763.3"
					y2="184.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.3"
					y1="184.12"
					x2="763.3"
					y2="177.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="760.44 179.61 760.44 182.47 609.03 182.47 609.03 179.61 760.44 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="760.44"
					y1="179.61"
					x2="760.44"
					y2="182.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="760.44"
					y1="182.47"
					x2="609.03"
					y2="182.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.03"
					y1="182.47"
					x2="609.03"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.03"
					y1="179.61"
					x2="760.44"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="825.88 179.61 831.61 179.61 831.61 196.8 825.88 196.8 825.88 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="831.61"
					y1="179.61"
					x2="825.88"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.61"
					y1="196.8"
					x2="831.61"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.88"
					y1="196.8"
					x2="831.61"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.88"
					y1="179.61"
					x2="825.88"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="757.57 179.61 763.3 179.61 763.3 196.8 757.57 196.8 757.57 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="763.3"
					y1="179.61"
					x2="757.57"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.3"
					y1="196.8"
					x2="763.3"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.57"
					y1="196.8"
					x2="763.3"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.57"
					y1="179.61"
					x2="757.57"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="606.17 179.61 611.9 179.61 611.9 196.8 606.17 196.8 606.17 179.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="611.9"
					y1="179.61"
					x2="606.17"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.9"
					y1="196.8"
					x2="611.9"
					y2="179.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.17"
					y1="196.8"
					x2="611.9"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.17"
					y1="179.61"
					x2="606.17"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.3"
					y1="884.07"
					x2="299.3"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="906.99"
					x2="412.47"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="412.47"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="408.17"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="406.74 908.42 412.47 908.42 412.47 906.99 406.74 906.99 406.74 908.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="406.74 884.07 412.47 884.07 412.47 882.63 406.74 882.63 406.74 884.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="406.74"
					y1="908.42"
					x2="412.47"
					y2="908.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="908.42"
					x2="412.47"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="906.99"
					x2="406.74"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.74"
					y1="906.99"
					x2="406.74"
					y2="908.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.73"
					y1="908.42"
					x2="300.73"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.74"
					y1="884.07"
					x2="412.47"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="884.07"
					x2="412.47"
					y2="882.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="882.63"
					x2="406.74"
					y2="882.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.74"
					y1="882.63"
					x2="406.74"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.73"
					y1="884.07"
					x2="300.73"
					y2="882.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="405.3 906.99 407.45 906.99 407.45 884.07 405.3 884.07 405.3 906.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="300.01 906.99 302.16 906.99 302.16 884.07 300.01 884.07 300.01 906.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="375.1 811.13 302.16 884.07 305.71 887.61 378.64 814.68 375.1 811.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="407.45"
					y1="884.07"
					x2="408.17"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.45"
					y1="906.99"
					x2="408.17"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="408.17"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.01"
					y1="884.07"
					x2="299.3"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.01"
					y1="906.99"
					x2="299.3"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.3"
					y1="884.07"
					x2="299.3"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.3"
					y1="906.99"
					x2="405.3"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.3"
					y1="884.07"
					x2="407.45"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.45"
					y1="884.07"
					x2="407.45"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.45"
					y1="906.99"
					x2="405.3"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.01"
					y1="906.99"
					x2="300.01"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.01"
					y1="884.07"
					x2="302.16"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.16"
					y1="884.07"
					x2="302.16"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.16"
					y1="906.99"
					x2="300.01"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.1"
					y1="811.13"
					x2="378.64"
					y2="814.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.64"
					y1="814.68"
					x2="305.71"
					y2="887.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.71"
					y1="887.61"
					x2="302.16"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.16"
					y1="884.07"
					x2="375.1"
					y2="811.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="408.17"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="408.17"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="412.47"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="884.07"
					x2="412.47"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="906.99"
					x2="412.47"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="408.17"
					y1="906.99"
					x2="412.47"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="299.3"
					y1="884.07"
					x2="299.3"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="299.3"
					y1="884.07"
					x2="299.3"
					y2="906.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="61"
					y1="906.99"
					x2="61"
					y2="884.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="83.92"
					y1="702.36"
					x2="107.55"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="107.55"
					y1="688.04"
					x2="107.55"
					y2="679.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="107.55"
					y1="679.44"
					x2="107.55"
					y2="620.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="176.07"
					y1="91.58"
					x2="176.07"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="606.17"
					y1="173.88"
					x2="606.17"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="439.01"
					x2="487.47"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="473.14"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="487.47"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="347.32"
					x2="487.47"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="473.14"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="487.47"
					y2="347.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="552.96"
					x2="473.14"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="487.47"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="473.14"
					y2="552.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="478.47"
					x2="473.14"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="487.47"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="473.14"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="473.14"
					y2="456.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="470.62"
					x2="473.14"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="552.96"
					x2="473.14"
					y2="560.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="487.47"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="488.9 348.76 488.9 343.03 487.47 343.03 487.47 348.76 488.9 348.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="487.47 437.57 487.47 443.3 488.9 443.3 488.9 437.57 487.47 437.57"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="473.14 348.76 473.14 343.03 471.71 343.03 471.71 348.76 473.14 348.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="471.71 437.57 471.71 443.3 473.14 443.3 473.14 437.57 471.71 437.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="488.9"
					y1="348.76"
					x2="488.9"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="343.03"
					x2="487.47"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="343.03"
					x2="487.47"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="348.76"
					x2="488.9"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="437.57"
					x2="487.47"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="443.3"
					x2="488.9"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="443.3"
					x2="488.9"
					y2="437.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="437.57"
					x2="487.47"
					y2="437.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="348.76"
					x2="473.14"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="343.03"
					x2="471.71"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="343.03"
					x2="471.71"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="348.76"
					x2="473.14"
					y2="348.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="437.57"
					x2="471.71"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="443.3"
					x2="473.14"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="443.3"
					x2="473.14"
					y2="437.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="437.57"
					x2="471.71"
					y2="437.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="487.47 350.19 487.47 348.04 473.14 348.04 473.14 350.19 487.47 350.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="487.47 438.29 487.47 436.14 473.14 436.14 473.14 438.29 487.47 438.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="412.37 375.36 473.14 436.14 476.69 432.6 415.91 371.82 412.37 375.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="473.14"
					y1="348.04"
					x2="473.14"
					y2="347.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="348.04"
					x2="487.47"
					y2="347.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="487.47"
					y2="347.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="438.29"
					x2="473.14"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="438.29"
					x2="487.47"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="487.47"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="350.19"
					x2="473.14"
					y2="350.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="350.19"
					x2="473.14"
					y2="348.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="348.04"
					x2="487.47"
					y2="348.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="348.04"
					x2="487.47"
					y2="350.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="438.29"
					x2="473.14"
					y2="438.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="438.29"
					x2="473.14"
					y2="436.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="436.14"
					x2="487.47"
					y2="436.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="436.14"
					x2="487.47"
					y2="438.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.37"
					y1="375.36"
					x2="415.91"
					y2="371.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.91"
					y1="371.82"
					x2="476.69"
					y2="432.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.69"
					y1="432.6"
					x2="473.14"
					y2="436.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="436.14"
					x2="412.37"
					y2="375.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="487.47"
					y2="347.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="487.47"
					y2="347.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="473.14"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="347.32"
					x2="473.14"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="347.32"
					x2="487.47"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="347.32"
					x2="487.47"
					y2="343.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="487.47"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="487.47"
					y2="439.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="473.14"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="439.01"
					x2="473.14"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="439.01"
					x2="487.47"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="439.01"
					x2="487.47"
					y2="443.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="471.71 479.9 473.14 479.9 473.14 474.17 471.71 474.17 471.71 479.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="473.14 551.52 471.71 551.52 471.71 557.26 473.14 557.26 473.14 551.52"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="487.47 479.9 488.9 479.9 488.9 474.17 487.47 474.17 487.47 479.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="488.9 551.52 487.47 551.52 487.47 557.26 488.9 557.26 488.9 551.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="471.71"
					y1="479.9"
					x2="471.71"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="474.17"
					x2="473.14"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="474.17"
					x2="473.14"
					y2="479.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="479.9"
					x2="471.71"
					y2="479.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="551.52"
					x2="473.14"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="557.25"
					x2="471.71"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="557.25"
					x2="471.71"
					y2="551.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.71"
					y1="551.52"
					x2="473.14"
					y2="551.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="479.9"
					x2="487.47"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="474.17"
					x2="488.9"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="474.17"
					x2="488.9"
					y2="479.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="479.9"
					x2="487.47"
					y2="479.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="551.52"
					x2="488.9"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.9"
					y1="557.25"
					x2="487.47"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="557.25"
					x2="487.47"
					y2="551.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="551.52"
					x2="488.9"
					y2="551.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="473.14 481.33 487.47 481.33 487.47 479.18 473.14 479.18 473.14 481.33"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="473.14 552.24 487.47 552.24 487.47 550.09 473.14 550.09 473.14 552.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="536.09 501.47 532.55 497.92 483.92 546.55 487.47 550.09 536.09 501.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="487.47"
					y1="479.18"
					x2="487.47"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="479.18"
					x2="473.14"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="473.14"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="552.24"
					x2="487.47"
					y2="552.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="552.24"
					x2="473.14"
					y2="552.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="473.14"
					y2="552.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="481.33"
					x2="487.47"
					y2="481.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="481.33"
					x2="487.47"
					y2="479.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="479.18"
					x2="473.14"
					y2="479.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="479.18"
					x2="473.14"
					y2="481.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="552.24"
					x2="487.47"
					y2="552.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="552.24"
					x2="487.47"
					y2="550.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="550.09"
					x2="473.14"
					y2="550.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.14"
					y1="550.09"
					x2="473.14"
					y2="552.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.09"
					y1="501.47"
					x2="532.55"
					y2="497.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.55"
					y1="497.92"
					x2="483.92"
					y2="546.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.92"
					y1="546.55"
					x2="487.47"
					y2="550.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="550.09"
					x2="536.09"
					y2="501.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="473.14"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="473.14"
					y2="478.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="487.47"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="478.47"
					x2="487.47"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="478.47"
					x2="473.14"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="478.47"
					x2="473.14"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="473.14"
					y2="552.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="473.14"
					y2="552.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="487.47"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="487.47"
					y1="552.96"
					x2="487.47"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="552.96"
					x2="473.14"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="473.14"
					y1="552.96"
					x2="473.14"
					y2="557.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="688.04"
					x2="335.36"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="335.36"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="339.66"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="688.04"
					x2="435.64"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="435.64"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="431.34"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="107.55"
					y1="702.36"
					x2="276.02"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="688.04"
					x2="107.55"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="429.91 686.6 429.91 688.04 435.64 688.04 435.64 686.6 429.91 686.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="341.09 688.04 341.09 686.6 335.36 686.6 335.36 688.04 341.09 688.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="429.91 702.36 429.91 703.8 435.64 703.8 435.64 702.36 429.91 702.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="341.09 703.8 341.09 702.36 335.36 702.36 335.36 703.8 341.09 703.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="429.91"
					y1="686.6"
					x2="435.64"
					y2="686.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.64"
					y1="686.6"
					x2="435.64"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.64"
					y1="688.04"
					x2="429.91"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.91"
					y1="688.04"
					x2="429.91"
					y2="686.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.09"
					y1="688.04"
					x2="335.36"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.36"
					y1="688.04"
					x2="335.36"
					y2="686.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.36"
					y1="686.6"
					x2="341.09"
					y2="686.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.09"
					y1="686.6"
					x2="341.09"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.91"
					y1="702.36"
					x2="435.64"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.64"
					y1="702.36"
					x2="435.64"
					y2="703.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.64"
					y1="703.8"
					x2="429.91"
					y2="703.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.91"
					y1="703.8"
					x2="429.91"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.09"
					y1="703.8"
					x2="335.36"
					y2="703.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.36"
					y1="703.8"
					x2="335.36"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.36"
					y1="702.36"
					x2="341.09"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.09"
					y1="702.36"
					x2="341.09"
					y2="703.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="428.48 688.04 428.48 702.36 430.63 702.36 430.63 688.04 428.48 688.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="340.38 688.04 340.38 702.36 342.52 702.36 342.52 688.04 340.38 688.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="403.3 763.14 406.85 759.6 346.07 698.82 342.52 702.36 403.3 763.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="430.63"
					y1="702.36"
					x2="431.34"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.63"
					y1="688.04"
					x2="431.34"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="431.34"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.38"
					y1="702.36"
					x2="339.66"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.38"
					y1="688.04"
					x2="339.66"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="339.66"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.48"
					y1="688.04"
					x2="428.48"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.48"
					y1="702.36"
					x2="430.63"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.63"
					y1="702.36"
					x2="430.63"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.63"
					y1="688.04"
					x2="428.48"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.38"
					y1="688.04"
					x2="340.38"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.38"
					y1="702.36"
					x2="342.52"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.52"
					y1="702.36"
					x2="342.52"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.52"
					y1="688.04"
					x2="340.38"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.3"
					y1="763.14"
					x2="406.85"
					y2="759.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.85"
					y1="759.6"
					x2="346.07"
					y2="698.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.07"
					y1="698.82"
					x2="342.52"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.52"
					y1="702.36"
					x2="403.3"
					y2="763.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="431.34"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="431.34"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="435.64"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="702.36"
					x2="435.64"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="688.04"
					x2="435.64"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="431.34"
					y1="688.04"
					x2="435.64"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="339.66"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="339.66"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="335.36"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="702.36"
					x2="335.36"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="688.04"
					x2="335.36"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="339.66"
					y1="688.04"
					x2="335.36"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="107.55"
					y1="620.65"
					x2="276.02"
					y2="620.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="859.32"
					x2="276.02"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="859.32"
					x2="290.35"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="859.32"
					x2="276.02"
					y2="859.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="767.64"
					x2="276.02"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="767.64"
					x2="290.35"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="767.64"
					x2="276.02"
					y2="767.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="620.65"
					x2="276.02"
					y2="688.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="274.59 769.07 276.02 769.07 276.02 763.34 274.59 763.34 274.59 769.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="276.02 857.89 274.59 857.89 274.59 863.62 276.02 863.62 276.02 857.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="290.35 769.07 291.78 769.07 291.78 763.34 290.35 763.34 290.35 769.07"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="291.78 857.89 290.35 857.89 290.35 863.62 291.78 863.62 291.78 857.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="274.59"
					y1="769.07"
					x2="274.59"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.59"
					y1="763.34"
					x2="276.02"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="763.34"
					x2="276.02"
					y2="769.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="769.07"
					x2="274.59"
					y2="769.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="857.89"
					x2="276.02"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="863.62"
					x2="274.59"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.59"
					y1="863.62"
					x2="274.59"
					y2="857.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.59"
					y1="857.89"
					x2="276.02"
					y2="857.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="769.07"
					x2="290.35"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="763.34"
					x2="291.78"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.78"
					y1="763.34"
					x2="291.78"
					y2="769.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.78"
					y1="769.07"
					x2="290.35"
					y2="769.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.78"
					y1="857.89"
					x2="291.78"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.78"
					y1="863.62"
					x2="290.35"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="863.62"
					x2="290.35"
					y2="857.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="857.89"
					x2="291.78"
					y2="857.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="290.35 770.51 290.35 768.35 276.02 768.35 276.02 770.51 290.35 770.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="290.35 858.61 290.35 856.46 276.02 856.46 276.02 858.61 290.35 858.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="215.24 795.68 276.02 856.46 279.57 852.91 218.79 792.13 215.24 795.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.02"
					y1="768.35"
					x2="276.02"
					y2="767.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="768.35"
					x2="290.35"
					y2="767.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="767.64"
					x2="290.35"
					y2="767.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="858.61"
					x2="276.02"
					y2="859.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="858.61"
					x2="290.35"
					y2="859.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="859.32"
					x2="290.35"
					y2="859.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="770.51"
					x2="276.02"
					y2="770.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="770.51"
					x2="276.02"
					y2="768.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="768.35"
					x2="290.35"
					y2="768.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="768.35"
					x2="290.35"
					y2="770.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="858.61"
					x2="276.02"
					y2="858.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="858.61"
					x2="276.02"
					y2="856.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="856.46"
					x2="290.35"
					y2="856.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="856.46"
					x2="290.35"
					y2="858.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.24"
					y1="795.68"
					x2="218.79"
					y2="792.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.79"
					y1="792.13"
					x2="279.57"
					y2="852.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.57"
					y1="852.91"
					x2="276.02"
					y2="856.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="856.46"
					x2="215.24"
					y2="795.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.35"
					y1="767.64"
					x2="276.02"
					y2="767.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="767.64"
					x2="276.02"
					y2="767.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="767.64"
					x2="290.35"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="767.64"
					x2="290.35"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="767.64"
					x2="276.02"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="767.64"
					x2="276.02"
					y2="763.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="859.32"
					x2="276.02"
					y2="859.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="859.32"
					x2="276.02"
					y2="859.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="859.32"
					x2="290.35"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.35"
					y1="859.32"
					x2="290.35"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="859.32"
					x2="276.02"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="276.02"
					y1="859.32"
					x2="276.02"
					y2="863.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="527.41"
					x2="106.75"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="524.55"
					x2="110.33"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="513.09"
					x2="106.75"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="513.09"
					x2="110.33"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="527.41"
					x2="333.09"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="524.55"
					x2="329.52"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="513.09"
					x2="333.09"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="513.09"
					x2="329.52"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="327.36 524.55 327.36 527.41 328.8 527.41 328.8 524.55 327.36 524.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.36 528.85 333.09 528.85 333.09 527.41 327.36 527.41 327.36 528.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="111.05 524.55 111.05 527.41 112.48 527.41 112.48 524.55 111.05 524.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="112.48 527.41 106.75 527.41 106.75 528.85 112.48 528.85 112.48 527.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="327.36 513.09 333.09 513.09 333.09 509.51 327.36 509.51 327.36 513.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="112.48 509.51 106.75 509.51 106.75 513.09 112.48 513.09 112.48 509.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="327.36"
					y1="524.55"
					x2="327.36"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.36"
					y1="527.41"
					x2="328.8"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.8"
					y1="527.41"
					x2="328.8"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.8"
					y1="524.55"
					x2="327.36"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.36"
					y1="528.85"
					x2="333.09"
					y2="528.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.09"
					y1="528.85"
					x2="333.09"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.09"
					y1="527.41"
					x2="327.36"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.36"
					y1="527.41"
					x2="327.36"
					y2="528.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.05"
					y1="524.55"
					x2="111.05"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.05"
					y1="527.41"
					x2="112.48"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.48"
					y1="527.41"
					x2="112.48"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.48"
					y1="524.55"
					x2="111.05"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.48"
					y1="527.41"
					x2="106.75"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.75"
					y1="527.41"
					x2="106.75"
					y2="528.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.75"
					y1="528.85"
					x2="112.48"
					y2="528.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.48"
					y1="528.85"
					x2="112.48"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.36"
					y1="513.09"
					x2="333.09"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.09"
					y1="513.09"
					x2="333.09"
					y2="509.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.09"
					y1="509.51"
					x2="327.36"
					y2="509.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="327.36"
					y1="509.51"
					x2="327.36"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.48"
					y1="509.51"
					x2="106.75"
					y2="509.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.75"
					y1="509.51"
					x2="106.75"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.75"
					y1="513.09"
					x2="112.48"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.48"
					y1="513.09"
					x2="112.48"
					y2="509.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="323.07 524.55 328.8 524.55 328.8 513.09 323.07 513.09 323.07 524.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="111.05 524.55 116.78 524.55 116.78 513.09 111.05 513.09 111.05 524.55"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="222.79 513.09 116.78 513.09 116.78 518.1 222.79 518.1 222.79 513.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="288.69 518.1 182.68 518.1 182.68 523.11 288.69 523.11 288.69 518.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="328.8"
					y1="513.09"
					x2="329.52"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.8"
					y1="524.55"
					x2="329.52"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.52"
					y1="513.09"
					x2="329.52"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.05"
					y1="513.09"
					x2="110.33"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.05"
					y1="524.55"
					x2="110.33"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.33"
					y1="513.09"
					x2="110.33"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.07"
					y1="524.55"
					x2="323.07"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="323.07"
					y1="513.09"
					x2="328.8"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.8"
					y1="513.09"
					x2="328.8"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.8"
					y1="524.55"
					x2="323.07"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.05"
					y1="524.55"
					x2="111.05"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.05"
					y1="513.09"
					x2="116.78"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.78"
					y1="513.09"
					x2="116.78"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.78"
					y1="524.55"
					x2="111.05"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.79"
					y1="513.09"
					x2="222.79"
					y2="518.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.79"
					y1="518.1"
					x2="116.78"
					y2="518.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.78"
					y1="518.1"
					x2="116.78"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.78"
					y1="513.09"
					x2="222.79"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.69"
					y1="518.1"
					x2="288.69"
					y2="523.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.69"
					y1="523.11"
					x2="182.68"
					y2="523.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.68"
					y1="523.11"
					x2="182.68"
					y2="518.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.68"
					y1="518.1"
					x2="288.69"
					y2="518.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.52"
					y1="513.09"
					x2="329.52"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="513.09"
					x2="329.52"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="524.55"
					x2="329.52"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="513.09"
					x2="333.09"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="524.55"
					x2="329.52"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="527.41"
					x2="333.09"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="329.52"
					y1="527.41"
					x2="333.09"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="513.09"
					x2="110.33"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="513.09"
					x2="110.33"
					y2="524.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="524.55"
					x2="110.33"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="513.09"
					x2="106.75"
					y2="513.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="524.55"
					x2="110.33"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="527.41"
					x2="106.75"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="110.33"
					y1="527.41"
					x2="106.75"
					y2="527.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="401.52"
					y1="91.58"
					x2="401.52"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="639.54"
					y1="861.05"
					x2="653.87"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="899.29"
					y1="642.35"
					x2="913.62"
					y2="642.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="927.08"
					y1="642.35"
					x2="913.62"
					y2="642.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="831.61"
					y1="173.88"
					x2="831.61"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="643.59 795.67 643.59 861.05 707.85 861.05 707.85 795.67 643.59 795.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="707.85"
					y1="795.67"
					x2="705.29"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.16"
					y1="795.67"
					x2="694.29"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.16"
					y1="795.67"
					x2="683.29"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.16"
					y1="795.67"
					x2="672.28"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.16"
					y1="795.67"
					x2="661.28"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.16"
					y1="795.67"
					x2="650.28"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.15"
					y1="795.67"
					x2="643.59"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="861.05"
					x2="707.85"
					y2="857.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="853.81"
					x2="707.85"
					y2="846.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="842.8"
					x2="707.85"
					y2="835.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="831.8"
					x2="707.85"
					y2="824.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="820.8"
					x2="707.85"
					y2="813.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="809.8"
					x2="707.85"
					y2="802.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.85"
					y1="798.8"
					x2="707.85"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="861.05"
					x2="646.15"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.28"
					y1="861.05"
					x2="657.16"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.28"
					y1="861.05"
					x2="668.16"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.28"
					y1="861.05"
					x2="679.16"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.29"
					y1="861.05"
					x2="690.16"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.29"
					y1="861.05"
					x2="701.16"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.29"
					y1="861.05"
					x2="707.85"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="795.67"
					x2="643.59"
					y2="798.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="802.92"
					x2="643.59"
					y2="809.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="813.92"
					x2="643.59"
					y2="820.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="824.93"
					x2="643.59"
					y2="831.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="835.93"
					x2="643.59"
					y2="842.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="846.93"
					x2="643.59"
					y2="853.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.59"
					y1="857.93"
					x2="643.59"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="707.6 792.29 707.6 790.32 643.84 790.32 643.84 792.29 653.84 792.29 653.84 790.67 697.6 790.67 697.6 792.29 707.6 792.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="697.6"
					y1="792.29"
					x2="707.6"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="697.6"
					y1="790.67"
					x2="697.6"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="653.84"
					y1="790.67"
					x2="697.6"
					y2="790.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="653.84"
					y1="792.29"
					x2="653.84"
					y2="790.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="643.84"
					y1="792.29"
					x2="653.84"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="643.84"
					y1="790.32"
					x2="643.84"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="707.6"
					y1="790.32"
					x2="643.84"
					y2="790.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="707.6"
					y1="792.29"
					x2="707.6"
					y2="790.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="710.1 792.29 641.34 792.29 641.34 795.67 710.1 795.67 710.1 792.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="710.1"
					y1="795.67"
					x2="710.1"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="641.34"
					y1="795.67"
					x2="710.1"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="641.34"
					y1="792.29"
					x2="641.34"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="710.1"
					y1="792.29"
					x2="641.34"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="643.84"
					y1="792.29"
					x2="643.84"
					y2="790.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.84"
					y1="790.32"
					x2="707.6"
					y2="790.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.6"
					y1="790.32"
					x2="707.6"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.34"
					y1="792.29"
					x2="710.1"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.6"
					y1="792.29"
					x2="697.6"
					y2="790.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.6"
					y1="790.67"
					x2="653.84"
					y2="790.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="653.84"
					y1="790.67"
					x2="653.84"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.34"
					y1="795.67"
					x2="641.34"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.1"
					y1="792.29"
					x2="710.1"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.1"
					y1="795.67"
					x2="641.34"
					y2="795.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="821.24 547.94 821.24 642.35 927.08 642.35 927.08 547.94 821.24 547.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="927.08"
					y1="547.94"
					x2="821.24"
					y2="547.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.08"
					y1="642.35"
					x2="927.08"
					y2="547.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.24"
					y1="642.35"
					x2="927.08"
					y2="642.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.24"
					y1="547.94"
					x2="821.24"
					y2="642.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.4"
					y1="547.94"
					x2="828.4"
					y2="642.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="824.8 671.79 824.8 757.75 899.29 757.75 899.29 671.79 824.8 671.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="824.8"
					y1="671.79"
					x2="824.8"
					y2="757.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.29"
					y1="671.79"
					x2="899.29"
					y2="757.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.03"
					y1="671.79"
					x2="897.03"
					y2="757.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.8"
					y1="671.79"
					x2="899.29"
					y2="671.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.8"
					y1="757.75"
					x2="899.29"
					y2="757.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.18"
					y1="677.44"
					x2="828.18"
					y2="752.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.18"
					y1="752.11"
					x2="830.44"
					y2="754.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.44"
					y1="754.36"
					x2="893.65"
					y2="754.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.65"
					y1="754.36"
					x2="895.91"
					y2="752.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.91"
					y1="752.11"
					x2="895.91"
					y2="677.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.91"
					y1="677.44"
					x2="893.65"
					y2="675.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.65"
					y1="675.18"
					x2="830.44"
					y2="675.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.44"
					y1="675.18"
					x2="828.18"
					y2="677.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m854.7,693.28c0-6.23-5.05-11.28-11.28-11.28s-11.28,5.05-11.28,11.28,5.05,11.28,11.28,11.28,11.28-5.05,11.28-11.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m889.13,693.28c0-4.67-3.79-8.46-8.46-8.46s-8.46,3.79-8.46,8.46,3.79,8.46,8.46,8.46,8.46-3.79,8.46-8.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m851.88,736.26c0-4.67-3.79-8.46-8.46-8.46s-8.46,3.79-8.46,8.46,3.79,8.46,8.46,8.46,8.46-3.79,8.46-8.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m891.95,736.26c0-6.23-5.05-11.28-11.28-11.28s-11.28,5.05-11.28,11.28,5.05,11.28,11.28,11.28,11.28-5.05,11.28-11.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="782.11 798.02 724.44 798.02 723.31 798.32 722.49 799.15 722.18 800.28 722.18 858.8 722.49 859.92 723.31 860.75 724.44 861.05 782.11 861.05 783.24 860.75 784.06 859.92 784.37 858.8 784.37 800.28 784.06 799.15 783.24 798.32 782.11 798.02"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m782.11,798.02c1.25,0,2.26,1.01,2.26,2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.37"
					y1="858.8"
					x2="784.37"
					y2="800.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m784.37,858.8c0,1.25-1.01,2.26-2.26,2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.44"
					y1="861.05"
					x2="782.11"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m724.44,861.05c-1.25,0-2.26-1.01-2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.18"
					y1="800.28"
					x2="722.18"
					y2="858.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m722.18,800.28c0-1.25,1.01-2.26,2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.11"
					y1="798.02"
					x2="724.44"
					y2="798.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.47"
					y1="803.66"
					x2="730.08"
					y2="803.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.83"
					y1="805.91"
					x2="727.83"
					y2="847.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="849.77"
					x2="776.47"
					y2="849.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.73"
					y1="847.52"
					x2="778.73"
					y2="805.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.47"
					y1="803.66"
					x2="776.47"
					y2="803.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m727.83,805.91c0-1.24,1.01-2.25,2.26-2.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m730.08,849.77c-1.25,0-2.26-1.01-2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m778.73,847.52c0,1.25-1.01,2.26-2.26,2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m776.47,803.66c1.24,0,2.26,1.01,2.26,2.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m756.66,838.49c0-1.87-1.51-3.38-3.38-3.38s-3.38,1.51-3.38,3.38,1.51,3.38,3.38,3.38,3.38-1.51,3.38-3.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="754.29 835.35 753.99 834.63 753.27 834.33 752.56 834.63 752.26 835.35 752.26 857.67 752.56 858.38 753.28 858.68 753.99 858.38 754.29 857.67 754.29 835.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="754.29"
					y1="857.67"
					x2="754.29"
					y2="835.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m754.29,857.67c0,.56-.45,1.02-1.01,1.02s-1.02-.45-1.02-1.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.26"
					y1="835.35"
					x2="752.26"
					y2="857.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m752.26,835.35h0c0-.57.45-1.02,1.02-1.02s1.01.45,1.01,1.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.53 851.91 754.29 851.91 754.29 857.67 753.99 858.38 753.28 858.68 752.56 858.38 752.26 857.67 752.26 851.91 751.02 851.91 751.02 859.25 755.53 859.25 755.53 851.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.53"
					y1="859.25"
					x2="755.53"
					y2="851.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.02"
					y1="859.25"
					x2="755.53"
					y2="859.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.02"
					y1="851.91"
					x2="751.02"
					y2="859.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.26"
					y1="851.91"
					x2="751.02"
					y2="851.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.26"
					y1="857.67"
					x2="752.26"
					y2="851.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m754.29,857.67c0,.56-.45,1.02-1.01,1.02s-1.02-.45-1.02-1.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.29"
					y1="851.91"
					x2="754.29"
					y2="857.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.53"
					y1="851.91"
					x2="754.29"
					y2="851.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.5 847.86 754.29 847.86 754.29 851.8 755.5 851.8 755.5 847.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.5"
					y1="851.8"
					x2="755.5"
					y2="847.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.29"
					y1="851.8"
					x2="755.5"
					y2="851.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.29"
					y1="847.86"
					x2="754.29"
					y2="851.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.5"
					y1="847.86"
					x2="754.29"
					y2="847.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="751.05 847.86 751.05 851.8 752.26 851.8 752.26 847.86 751.05 847.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="752.26"
					y1="847.86"
					x2="751.05"
					y2="847.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.26"
					y1="851.8"
					x2="752.26"
					y2="847.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.05"
					y1="851.8"
					x2="752.26"
					y2="851.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.05"
					y1="847.86"
					x2="751.05"
					y2="851.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="159.16 842.64 161.44 837.53 162.24 831.98 161.44 826.44 159.16 821.33 156.27 817.96 152.63 815.4 144.11 812.16 137.03 811.01 129.87 811.44 122.97 813.42 116.67 813.26 110.57 811.66 104.99 808.72 102.57 807.17 97.59 805.36 92.3 805.63 90.21 806.45 84.64 806.45 84.64 808.78 87.18 808.78 84.83 812.66 83.92 817.1 83.92 846.87 84.82 851.26 87.25 855.03 90.89 857.66 95.23 858.79 95.91 858.79 99.49 858.2 105.12 855.18 110.63 852.25 116.67 850.67 122.9 850.51 129.82 852.52 137 852.95 144.11 851.81 152.63 848.56 156.27 846.01 159.16 842.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="110.38"
					y1="821.38"
					x2="110.38"
					y2="842.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.92"
					y1="846.87"
					x2="83.92"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.99"
					y1="846.87"
					x2="84.99"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.92"
					y1="817.1"
					x2="83.92"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.99"
					y1="817.1"
					x2="84.99"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.38"
					y1="842.04"
					x2="106.41"
					y2="842.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.41"
					y1="842.04"
					x2="106.41"
					y2="838.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.41"
					y1="838.76"
					x2="110.38"
					y2="838.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.38"
					y1="821.93"
					x2="106.41"
					y2="821.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.41"
					y1="821.93"
					x2="106.41"
					y2="825.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="106.41"
					y1="825.21"
					x2="110.38"
					y2="825.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.49"
					y1="808.78"
					x2="84.64"
					y2="808.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.49"
					y1="806.45"
					x2="84.64"
					y2="806.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.64"
					y1="806.45"
					x2="84.64"
					y2="808.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.49"
					y1="806.45"
					x2="94.49"
					y2="808.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.24"
					y1="831.98"
					x2="161.83"
					y2="835.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.83"
					y1="835.54"
					x2="160.91"
					y2="838.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.91"
					y1="838.98"
					x2="159.16"
					y2="842.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.16"
					y1="842.64"
					x2="157.82"
					y2="844.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.82"
					y1="844.44"
					x2="156.27"
					y2="846.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.27"
					y1="846.01"
					x2="152.63"
					y2="848.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.63"
					y1="848.56"
					x2="148.5"
					y2="850.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.5"
					y1="850.44"
					x2="144.11"
					y2="851.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.11"
					y1="851.81"
					x2="140.58"
					y2="852.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.58"
					y1="852.59"
					x2="137.01"
					y2="853.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.01"
					y1="853.05"
					x2="133.43"
					y2="853.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.43"
					y1="853.11"
					x2="129.87"
					y2="852.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.87"
					y1="852.71"
					x2="124.34"
					y2="851.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.34"
					y1="851.1"
					x2="118.98"
					y2="848.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.98"
					y1="848.59"
					x2="114.2"
					y2="845.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.2"
					y1="845.61"
					x2="110.38"
					y2="842.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.9"
					y1="850.51"
					x2="117.94"
					y2="850.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.94"
					y1="850.54"
					x2="113.1"
					y2="851.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.1"
					y1="851.36"
					x2="110.5"
					y2="852.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.5"
					y1="852.2"
					x2="107.92"
					y2="853.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.92"
					y1="853.41"
					x2="104.17"
					y2="855.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.17"
					y1="855.81"
					x2="100.28"
					y2="857.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.28"
					y1="857.92"
					x2="98.41"
					y2="858.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.41"
					y1="858.49"
					x2="96.49"
					y2="858.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.49"
					y1="858.77"
					x2="94.58"
					y2="858.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.58"
					y1="858.75"
					x2="92.71"
					y2="858.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.71"
					y1="858.44"
					x2="90.93"
					y2="857.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.93"
					y1="857.85"
					x2="89.28"
					y2="856.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.28"
					y1="856.97"
					x2="87.79"
					y2="855.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.79"
					y1="855.81"
					x2="86.51"
					y2="854.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.51"
					y1="854.37"
					x2="85.1"
					y2="851.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.1"
					y1="851.83"
					x2="84.33"
					y2="849.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.33"
					y1="849.4"
					x2="83.92"
					y2="846.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.99"
					y1="846.87"
					x2="85.1"
					y2="848"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.1"
					y1="848"
					x2="85.83"
					y2="850.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.83"
					y1="850.34"
					x2="86.59"
					y2="851.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.59"
					y1="851.47"
					x2="87.57"
					y2="852.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.57"
					y1="852.41"
					x2="90"
					y2="853.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90"
					y1="853.7"
					x2="93.19"
					y2="854.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.19"
					y1="854.32"
					x2="96.48"
					y2="854.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.48"
					y1="854.46"
					x2="98.12"
					y2="854.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.12"
					y1="854.44"
					x2="98.84"
					y2="854.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.84"
					y1="854.22"
					x2="99.42"
					y2="853.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.42"
					y1="853.75"
					x2="99.8"
					y2="852.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.8"
					y1="852.94"
					x2="102.35"
					y2="843.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.35"
					y1="843.94"
					x2="103.11"
					y2="839.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.11"
					y1="839.47"
					x2="103.44"
					y2="834.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.44"
					y1="834.94"
					x2="103.44"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="122.97"
					y1="813.42"
					x2="117.99"
					y2="813.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.99"
					y1="813.38"
					x2="113.14"
					y2="812.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.14"
					y1="812.57"
					x2="110.52"
					y2="811.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.52"
					y1="811.75"
					x2="107.92"
					y2="810.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.92"
					y1="810.55"
					x2="104.16"
					y2="808.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.16"
					y1="808.17"
					x2="100.28"
					y2="806.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="100.28"
					y1="806.05"
					x2="97.75"
					y2="805.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.75"
					y1="805.35"
					x2="95.15"
					y2="805.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.15"
					y1="805.19"
					x2="92.59"
					y2="805.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.59"
					y1="805.55"
					x2="90.21"
					y2="806.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.99"
					y1="817.1"
					x2="85.1"
					y2="815.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.1"
					y1="815.96"
					x2="85.83"
					y2="813.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.83"
					y1="813.63"
					x2="86.59"
					y2="812.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.59"
					y1="812.5"
					x2="87.57"
					y2="811.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.57"
					y1="811.56"
					x2="90"
					y2="810.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90"
					y1="810.26"
					x2="93.19"
					y2="809.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.19"
					y1="809.65"
					x2="96.48"
					y2="809.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.48"
					y1="809.51"
					x2="98.12"
					y2="809.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.12"
					y1="809.53"
					x2="98.84"
					y2="809.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.84"
					y1="809.74"
					x2="99.42"
					y2="810.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.42"
					y1="810.22"
					x2="99.8"
					y2="811.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="99.8"
					y1="811.02"
					x2="102.35"
					y2="820.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.35"
					y1="820.03"
					x2="103.11"
					y2="824.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.11"
					y1="824.5"
					x2="103.44"
					y2="829.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.44"
					y1="829.03"
					x2="103.44"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.24"
					y1="831.98"
					x2="161.83"
					y2="828.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="161.83"
					y1="828.43"
					x2="160.91"
					y2="824.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.91"
					y1="824.99"
					x2="159.16"
					y2="821.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.16"
					y1="821.33"
					x2="157.82"
					y2="819.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.82"
					y1="819.53"
					x2="156.27"
					y2="817.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="156.27"
					y1="817.96"
					x2="152.63"
					y2="815.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.63"
					y1="815.4"
					x2="148.5"
					y2="813.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.5"
					y1="813.52"
					x2="144.11"
					y2="812.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.11"
					y1="812.16"
					x2="140.58"
					y2="811.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="140.58"
					y1="811.38"
					x2="137.01"
					y2="810.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.01"
					y1="810.92"
					x2="133.43"
					y2="810.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="133.43"
					y1="810.85"
					x2="129.87"
					y2="811.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.87"
					y1="811.26"
					x2="124.34"
					y2="812.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="124.34"
					y1="812.87"
					x2="118.98"
					y2="815.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.98"
					y1="815.37"
					x2="114.2"
					y2="818.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="114.2"
					y1="818.35"
					x2="110.38"
					y2="821.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.35"
					y1="856.92"
					x2="103.16"
					y2="856.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.16"
					y1="856.35"
					x2="104.37"
					y2="854.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.37"
					y1="854.71"
					x2="104.65"
					y2="853.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.65"
					y1="853.29"
					x2="105.43"
					y2="844.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.43"
					y1="844.15"
					x2="105.79"
					y2="834.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.79"
					y1="834.98"
					x2="105.79"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="102.35"
					y1="807.04"
					x2="103.16"
					y2="807.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="103.16"
					y1="807.61"
					x2="104.37"
					y2="809.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.37"
					y1="809.25"
					x2="104.65"
					y2="810.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.65"
					y1="810.67"
					x2="105.43"
					y2="819.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.43"
					y1="819.81"
					x2="105.79"
					y2="828.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="105.79"
					y1="828.98"
					x2="105.79"
					y2="831.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="87.18"
					y1="808.78"
					x2="86.51"
					y2="809.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.51"
					y1="809.6"
					x2="85.11"
					y2="812.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.11"
					y1="812.13"
					x2="84.33"
					y2="814.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.33"
					y1="814.56"
					x2="83.92"
					y2="817.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="137.26 780.79 137.26 702.36 83.92 702.36 83.92 780.79 137.26 780.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="137.26"
					y1="780.79"
					x2="137.26"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.92"
					y1="780.79"
					x2="83.92"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.26"
					y1="702.36"
					x2="83.92"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="137.26"
					y1="780.79"
					x2="83.92"
					y2="780.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.18"
					y1="780.79"
					x2="86.18"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.63"
					y1="770.23"
					x2="125.63"
					y2="712.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.63"
					y1="712.92"
					x2="91.25"
					y2="712.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.25"
					y1="712.92"
					x2="91.25"
					y2="770.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.25"
					y1="770.23"
					x2="125.63"
					y2="770.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.89"
					y1="772.48"
					x2="127.89"
					y2="710.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.89"
					y1="710.67"
					x2="89"
					y2="710.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89"
					y1="710.67"
					x2="89"
					y2="772.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89"
					y1="772.48"
					x2="127.89"
					y2="772.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m102.4,741.58c0-1.87-1.52-3.38-3.38-3.38s-3.38,1.51-3.38,3.38,1.52,3.38,3.38,3.38,3.38-1.51,3.38-3.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="85.95 744.4 90.68 743.94 91.75 743.58 97.72 742.83 98.51 742.41 98.83 741.58 98.51 740.74 97.72 740.32 91.75 739.57 90.68 739.2 85.95 738.75 84.29 739.29 83.27 740.7 83.27 742.44 84.29 743.86 85.95 744.4"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m85.95,744.4c-1.56,0-2.82-1.26-2.82-2.82s1.26-2.82,2.82-2.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.68"
					y1="739.2"
					x2="85.95"
					y2="738.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m90.68,739.2c.38.04.75.16,1.07.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="97.72"
					y1="740.32"
					x2="91.75"
					y2="739.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m97.72,740.32c.63.08,1.1.62,1.1,1.25s-.47,1.17-1.1,1.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.75"
					y1="743.58"
					x2="97.72"
					y2="742.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m91.75,743.58c-.32.21-.69.33-1.07.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.95"
					y1="744.4"
					x2="90.68"
					y2="743.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.76"
					y1="740.04"
					x2="90.44"
					y2="740.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="90.44"
					y1="743.11"
					x2="88.76"
					y2="743.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="88.76"
					y1="743.11"
					x2="88.76"
					y2="740.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m90.44,740.04c.85,0,1.53.69,1.53,1.54s-.69,1.53-1.53,1.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m91.75,739.57c.68.44,1.09,1.19,1.09,2s-.41,1.56-1.09,2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="83.92 866.36 85.07 866.36 85.07 860.63 83.92 860.63 83.92 866.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="83.92"
					y1="860.63"
					x2="83.92"
					y2="866.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="860.63"
					x2="83.92"
					y2="860.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="866.36"
					x2="85.07"
					y2="860.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.92"
					y1="866.36"
					x2="85.07"
					y2="866.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="83.92 797.6 83.92 803.33 85.07 803.33 85.07 797.6 83.92 797.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="85.07"
					y1="797.6"
					x2="83.92"
					y2="797.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="803.33"
					x2="85.07"
					y2="797.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.92"
					y1="803.33"
					x2="85.07"
					y2="803.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="83.92"
					y1="797.6"
					x2="83.92"
					y2="803.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="85.07 864.07 94.39 864.07 94.39 862.93 85.07 862.93 85.07 864.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="85.07"
					y1="862.93"
					x2="85.07"
					y2="864.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.39"
					y1="862.93"
					x2="85.07"
					y2="862.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.39"
					y1="864.07"
					x2="94.39"
					y2="862.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="864.07"
					x2="94.39"
					y2="864.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="85.07 799.9 85.07 801.04 94.39 801.04 94.39 799.9 85.07 799.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="94.39"
					y1="799.9"
					x2="85.07"
					y2="799.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.39"
					y1="801.04"
					x2="94.39"
					y2="799.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="801.04"
					x2="94.39"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="799.9"
					x2="85.07"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="91.53 862.93 93.82 862.93 93.82 801.04 91.53 801.04 91.53 862.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="91.53"
					y1="801.04"
					x2="91.53"
					y2="862.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.82"
					y1="801.04"
					x2="91.53"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.82"
					y1="862.93"
					x2="93.82"
					y2="801.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="91.53"
					y1="862.93"
					x2="93.82"
					y2="862.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="107.55 620.65 107.55 702.36 276.02 702.36 276.02 620.65 107.55 620.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.02"
					y1="620.65"
					x2="107.55"
					y2="620.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="702.36"
					x2="276.02"
					y2="620.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.55"
					y1="702.36"
					x2="276.02"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.55"
					y1="620.65"
					x2="107.55"
					y2="702.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="118.1 630.33 118.1 691.61 264.74 691.61 264.74 630.33 118.1 630.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="264.74"
					y1="630.33"
					x2="118.1"
					y2="630.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.74"
					y1="691.61"
					x2="264.74"
					y2="630.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.1"
					y1="691.61"
					x2="264.74"
					y2="691.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.1"
					y1="630.33"
					x2="118.1"
					y2="691.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="132.51 661.51 132.46 660.96 132.32 660.42 132.08 659.92 131.76 659.47 131.36 659.08 130.9 658.76 130.4 658.53 129.85 658.38 129.3 658.34 128.74 658.38 128.19 658.53 127.69 658.76 127.23 659.08 126.83 659.47 126.51 659.92 126.27 660.42 126.13 660.96 126.08 661.51 126.13 662.06 126.27 662.59 126.51 663.09 126.83 663.54 127.23 663.93 127.69 664.25 128.19 664.48 128.74 664.63 129.3 664.67 129.85 664.63 130.4 664.48 130.9 664.25 131.36 663.93 131.76 663.54 132.08 663.09 132.32 662.59 132.46 662.06 132.51 661.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="132.46"
					y1="662.06"
					x2="132.51"
					y2="661.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.32"
					y1="662.59"
					x2="132.46"
					y2="662.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.08"
					y1="663.09"
					x2="132.32"
					y2="662.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.76"
					y1="663.54"
					x2="132.08"
					y2="663.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.36"
					y1="663.93"
					x2="131.76"
					y2="663.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.9"
					y1="664.25"
					x2="131.36"
					y2="663.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.4"
					y1="664.48"
					x2="130.9"
					y2="664.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.85"
					y1="664.63"
					x2="130.4"
					y2="664.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.3"
					y1="664.67"
					x2="129.85"
					y2="664.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.74"
					y1="664.63"
					x2="129.3"
					y2="664.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.19"
					y1="664.48"
					x2="128.74"
					y2="664.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.69"
					y1="664.25"
					x2="128.19"
					y2="664.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.23"
					y1="663.93"
					x2="127.69"
					y2="664.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.83"
					y1="663.54"
					x2="127.23"
					y2="663.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.51"
					y1="663.09"
					x2="126.83"
					y2="663.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.27"
					y1="662.59"
					x2="126.51"
					y2="663.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.13"
					y1="662.06"
					x2="126.27"
					y2="662.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.08"
					y1="661.51"
					x2="126.13"
					y2="662.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.13"
					y1="660.96"
					x2="126.08"
					y2="661.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.27"
					y1="660.42"
					x2="126.13"
					y2="660.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.51"
					y1="659.92"
					x2="126.27"
					y2="660.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="126.83"
					y1="659.47"
					x2="126.51"
					y2="659.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.23"
					y1="659.08"
					x2="126.83"
					y2="659.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.69"
					y1="658.76"
					x2="127.23"
					y2="659.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.19"
					y1="658.53"
					x2="127.69"
					y2="658.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.74"
					y1="658.38"
					x2="128.19"
					y2="658.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.3"
					y1="658.34"
					x2="128.74"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="129.85"
					y1="658.38"
					x2="129.3"
					y2="658.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.4"
					y1="658.53"
					x2="129.85"
					y2="658.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.9"
					y1="658.76"
					x2="130.4"
					y2="658.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.36"
					y1="659.08"
					x2="130.9"
					y2="658.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="131.76"
					y1="659.47"
					x2="131.36"
					y2="659.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.08"
					y1="659.92"
					x2="131.76"
					y2="659.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.32"
					y1="660.42"
					x2="132.08"
					y2="659.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.46"
					y1="660.96"
					x2="132.32"
					y2="660.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="132.51"
					y1="661.51"
					x2="132.46"
					y2="660.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="114.34 664.24 113.86 664.2 113.39 664.08 112.95 663.87 112.55 663.6 112.21 663.26 111.93 662.87 111.73 662.44 111.6 661.98 111.56 661.51 111.6 661.03 111.73 660.57 111.93 660.14 112.21 659.75 112.55 659.41 112.95 659.14 113.39 658.94 113.86 658.82 114.34 658.77 119 659.21 119.37 659.27 119.72 659.39 120.05 659.57 125.93 660.29 126.13 660.34 126.33 660.41 126.51 660.52 126.67 660.66 126.8 660.82 126.91 661 126.98 661.2 127.01 661.4 127.01 661.61 126.98 661.82 126.91 662.01 126.8 662.19 126.67 662.35 126.51 662.49 126.33 662.6 126.13 662.68 125.93 662.72 120.05 663.45 119.72 663.62 119.37 663.74 119 663.8 114.34 664.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="114.34"
					y1="664.24"
					x2="119"
					y2="663.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="120.05"
					y1="663.45"
					x2="125.93"
					y2="662.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.93"
					y1="660.29"
					x2="120.05"
					y2="659.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="119"
					y1="659.21"
					x2="114.34"
					y2="658.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.1"
					y1="660.02"
					x2="118.75"
					y2="660.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="118.75"
					y1="662.99"
					x2="117.1"
					y2="662.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="117.1"
					y1="662.99"
					x2="117.1"
					y2="660.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m120.05,663.44c-.32.2-.68.33-1.06.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m125.93,660.29c.62.08,1.09.6,1.09,1.21s-.47,1.14-1.09,1.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m119,659.21c.38.03.74.15,1.06.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m114.34,664.24c-1.53,0-2.78-1.22-2.78-2.73s1.24-2.73,2.78-2.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m118.75,660.02c.83,0,1.51.66,1.51,1.49s-.68,1.49-1.51,1.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m120.05,659.57c.67.42,1.07,1.15,1.07,1.94s-.4,1.51-1.07,1.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.23"
					y1="542.19"
					x2="460.28"
					y2="542.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.28"
					y1="542.19"
					x2="460.28"
					y2="487.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.23"
					y1="553.64"
					x2="440.23"
					y2="476.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.66"
					y1="476.29"
					x2="388.66"
					y2="553.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.66"
					y1="553.64"
					x2="466.01"
					y2="553.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.01"
					y1="476.29"
					x2="388.66"
					y2="476.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.58"
					y1="553.64"
					x2="464.58"
					y2="476.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.23"
					y1="487.75"
					x2="460.28"
					y2="487.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.01"
					y1="553.64"
					x2="466.01"
					y2="476.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.24"
					y1="639.48"
					x2="815.58"
					y2="639.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.58"
					y1="639.48"
					x2="815.58"
					y2="636.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="815.58"
					y1="636.62"
					x2="821.24"
					y2="636.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="547.94"
					x2="830.53"
					y2="554.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="558.7"
					x2="830.53"
					y2="565.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="569.7"
					x2="830.53"
					y2="576.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="580.71"
					x2="830.53"
					y2="587.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="591.71"
					x2="830.53"
					y2="598.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="602.71"
					x2="830.53"
					y2="609.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="613.71"
					x2="830.53"
					y2="620.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="624.71"
					x2="830.53"
					y2="631.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="635.72"
					x2="830.53"
					y2="642.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="642.35"
					x2="864.91"
					y2="644.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="648.56"
					x2="864.91"
					y2="655.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="659.56"
					x2="864.91"
					y2="666.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="670.56"
					x2="864.91"
					y2="677.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="681.56"
					x2="864.91"
					y2="688.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="692.56"
					x2="864.91"
					y2="699.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="703.57"
					x2="864.91"
					y2="710.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="714.57"
					x2="864.91"
					y2="721.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="725.57"
					x2="864.91"
					y2="732.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="736.57"
					x2="864.91"
					y2="743.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="747.57"
					x2="864.91"
					y2="754.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="758.58"
					x2="864.91"
					y2="765.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="769.58"
					x2="864.91"
					y2="776.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="780.58"
					x2="864.91"
					y2="787.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="791.58"
					x2="864.91"
					y2="798.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="802.59"
					x2="864.91"
					y2="809.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="813.58"
					x2="864.91"
					y2="820.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="824.54"
					x2="864.91"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="642.35"
					x2="830.53"
					y2="671.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.91"
					y1="826.67"
					x2="858.81"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.68"
					y1="826.67"
					x2="847.81"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.68"
					y1="826.67"
					x2="836.8"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.68"
					y1="826.67"
					x2="825.8"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="821.68"
					y1="826.67"
					x2="814.8"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.67"
					y1="826.67"
					x2="803.8"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.67"
					y1="826.67"
					x2="792.8"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.67"
					y1="826.67"
					x2="781.8"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.67"
					y1="826.67"
					x2="770.79"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.67"
					y1="826.67"
					x2="759.79"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.67"
					y1="826.67"
					x2="748.79"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.66"
					y1="826.67"
					x2="737.79"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.66"
					y1="826.67"
					x2="726.79"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.66"
					y1="826.67"
					x2="715.78"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.66"
					y1="826.67"
					x2="704.78"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="700.66"
					y1="826.67"
					x2="693.78"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.65"
					y1="826.67"
					x2="682.78"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.65"
					y1="826.67"
					x2="671.78"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.65"
					y1="826.67"
					x2="660.77"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.65"
					y1="826.67"
					x2="649.77"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.65"
					y1="826.67"
					x2="639.54"
					y2="826.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="792.29"
					x2="639.54"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.54"
					y1="792.29"
					x2="639.54"
					y2="861.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.53"
					y1="757.75"
					x2="830.53"
					y2="792.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.07"
					y1="114.5"
					x2="401.52"
					y2="114.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="176.07"
					y1="91.58"
					x2="401.52"
					y2="91.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.17"
					y1="173.88"
					x2="831.61"
					y2="173.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.61"
					y1="196.8"
					x2="606.17"
					y2="196.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.25"
					y1="542.19"
					x2="397.25"
					y2="487.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.25"
					y1="487.75"
					x2="434.5"
					y2="487.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.5"
					y1="487.75"
					x2="434.5"
					y2="542.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.5"
					y1="542.19"
					x2="397.25"
					y2="542.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="473.14 478.46 473.14 470.62 381.25 470.62 381.25 560.88 473.14 560.88 473.14 552.96 487.47 552.96 487.47 702.36 431.34 702.36 431.34 688.04 473.14 688.04 473.14 620.65 290.34 620.65 290.34 688.04 339.66 688.04 339.66 702.36 290.34 702.36 290.34 767.64 276.02 767.64 276.02 620.65 107.55 620.65 107.55 702.36 83.92 702.36 83.92 884.07 276.02 884.07 276.02 859.32 290.34 859.32 290.34 884.07 299.3 884.07 299.3 906.99 61 906.99 61 679.44 84.63 679.44 84.63 629.25 50 629.25 50 91.58 176.07 91.58 176.07 114.5 116.19 114.5 116.19 162.68 72.92 162.68 72.92 513.09 110.33 513.09 110.33 527.41 72.92 527.41 72.92 606.33 366.93 606.33 366.93 527.41 329.51 527.41 329.51 513.09 366.93 513.09 366.93 456.3 473.14 456.3 473.14 439.01 487.47 439.01 487.47 478.46 473.14 478.46"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="606.16 173.88 606.16 196.8 487.47 196.8 487.47 347.32 473.14 347.32 473.14 270.96 401.51 270.96 401.51 91.58 496.07 91.58 496.07 173.88 606.16 173.88"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
				<polygon
					points="950 173.88 950 906.99 408.17 906.99 408.17 884.07 639.55 884.07 639.55 861.05 899.29 861.05 899.29 642.35 927.08 642.35 927.08 196.8 831.61 196.8 831.61 173.88 950 173.88"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.11"
				/>
			</g>
			<g id="text">
				<path d="m661.68,818.82v-13.28h4.58c1.03,0,1.82.06,2.36.19.76.18,1.41.49,1.95.95.7.59,1.22,1.35,1.57,2.27.35.92.53,1.97.53,3.15,0,1.01-.12,1.9-.35,2.68-.24.78-.54,1.43-.91,1.94-.37.51-.77.91-1.21,1.21-.43.29-.96.51-1.59.66-.62.15-1.33.23-2.13.23h-4.79Zm1.76-1.57h2.84c.88,0,1.56-.08,2.06-.24.5-.16.9-.39,1.2-.69.42-.42.74-.98.97-1.68.24-.71.35-1.56.35-2.56,0-1.39-.23-2.46-.69-3.2-.45-.75-1.01-1.25-1.66-1.5-.47-.18-1.23-.27-2.27-.27h-2.79v10.15Zm13.97,1.57l-3.52-13.28h1.8l2.02,8.71c.22.91.4,1.82.56,2.72.34-1.42.54-2.24.6-2.46l2.53-8.97h2.12l1.9,6.72c.48,1.67.82,3.23,1.03,4.7.17-.84.39-1.8.66-2.89l2.08-8.53h1.77l-3.64,13.28h-1.69l-2.8-10.12c-.24-.85-.37-1.37-.42-1.56-.14.61-.27,1.13-.39,1.56l-2.82,10.12h-1.79Z" />
				<path d="m869.96,603.11h-1.87l-2.24-3.75c-.21-.35-.4-.64-.6-.89-.19-.25-.39-.45-.6-.61-.2-.16-.42-.27-.65-.34-.23-.07-.49-.11-.78-.11h-1.29v5.69h-1.57v-13.38h3.99c.58,0,1.12.07,1.61.22.5.14.93.36,1.29.66.37.3.65.67.86,1.12.21.44.31.96.31,1.56,0,.47-.07.9-.21,1.29-.14.39-.34.73-.6,1.04-.25.3-.57.57-.93.78-.36.21-.77.38-1.22.49v.04c.22.1.42.21.58.35.17.12.33.27.48.45.15.17.3.37.44.6.15.22.31.47.49.76l2.51,4.02Zm-8.02-11.96v4.85h2.13c.39,0,.75-.06,1.08-.18.34-.12.63-.29.87-.5.24-.22.43-.49.57-.81.14-.32.21-.68.21-1.08,0-.72-.23-1.27-.7-1.67-.46-.4-1.13-.61-2.01-.61h-2.15Zm17.16,7.57h-6.74c.02,1.06.31,1.88.86,2.46.55.58,1.3.87,2.26.87,1.08,0,2.06-.35,2.97-1.06v1.44c-.84.61-1.95.91-3.33.91s-2.41-.43-3.18-1.3c-.77-.87-1.16-2.09-1.16-3.67,0-1.49.42-2.7,1.26-3.63.85-.94,1.89-1.41,3.14-1.41s2.22.4,2.9,1.21c.68.81,1.03,1.93,1.03,3.37v.8Zm-1.57-1.3c0-.88-.22-1.57-.64-2.06-.42-.49-1-.74-1.74-.74s-1.33.26-1.84.77c-.5.52-.81,1.19-.93,2.02h5.16Zm8.43-7.11c-.3-.17-.64-.25-1.02-.25-1.07,0-1.6.67-1.6,2.02v1.47h2.24v1.31h-2.24v8.25h-1.52v-8.25h-1.63v-1.31h1.63v-1.55c0-1,.29-1.79.87-2.37.58-.58,1.3-.88,2.16-.88.47,0,.84.06,1.11.17v1.38Z" />
				<path d="m887.58,603.31c-.29,0-.53-.1-.74-.31-.2-.21-.3-.45-.3-.74s.1-.53.3-.74c.21-.21.45-.32.74-.32s.54.11.75.32c.21.21.31.45.31.74s-.1.53-.31.74c-.21.21-.45.31-.75.31Z" />
				<path d="m151.61,802.76v-20.77h5.91c1.8,0,3.22.44,4.27,1.32,1.05.88,1.58,2.02,1.58,3.43,0,1.18-.32,2.2-.96,3.07-.64.87-1.52,1.49-2.64,1.85v.06c1.4.16,2.52.7,3.36,1.59.84.89,1.26,2.05,1.26,3.48,0,1.78-.64,3.21-1.91,4.32-1.27,1.1-2.88,1.65-4.82,1.65h-6.05Zm2.43-18.56v6.7h2.49c1.33,0,2.38-.32,3.14-.96.76-.65,1.14-1.55,1.14-2.72,0-2.02-1.33-3.03-3.98-3.03h-2.79Zm0,8.89v7.47h3.3c1.43,0,2.53-.34,3.32-1.01.79-.68,1.19-1.6,1.19-2.78,0-2.45-1.67-3.68-5.01-3.68h-2.79Zm24.86,9.67h-2.37v-2.32h-.06c-1.03,1.78-2.55,2.66-4.56,2.66-1.48,0-2.64-.39-3.48-1.17-.83-.78-1.25-1.82-1.25-3.11,0-2.77,1.63-4.38,4.89-4.84l4.45-.62c0-2.52-1.02-3.78-3.06-3.78-1.79,0-3.4.61-4.84,1.82v-2.43c1.46-.93,3.14-1.39,5.04-1.39,3.49,0,5.23,1.84,5.23,5.53v9.64Zm-2.37-7.5l-3.58.49c-1.1.15-1.93.43-2.49.83-.56.39-.84,1.08-.84,2.07,0,.72.26,1.32.77,1.78.52.45,1.21.68,2.07.68,1.18,0,2.15-.41,2.91-1.23.77-.83,1.16-1.88,1.16-3.14v-1.48Zm13.73,7.36c-.56.31-1.3.46-2.22.46-2.6,0-3.9-1.45-3.9-4.34v-8.78h-2.55v-2.03h2.55v-3.62l2.37-.77v4.39h3.74v2.03h-3.74v8.36c0,.99.17,1.7.51,2.13.34.42.9.64,1.68.64.6,0,1.12-.16,1.55-.49v2.03Zm15.48.14h-2.37v-8.54c0-3.09-1.15-4.63-3.45-4.63-1.16,0-2.13.45-2.93,1.35-.79.89-1.19,2.03-1.19,3.43v8.4h-2.37v-21.95h2.37v9.59h.06c1.14-1.87,2.76-2.81,4.87-2.81,3.34,0,5.01,2.01,5.01,6.04v9.14Z" />
				<path d="m356.65,799.11h-11.01v-20.77h10.54v2.2h-8.11v6.91h7.5v2.19h-7.5v7.27h8.57v2.2Zm16.02,0h-2.37v-8.46c0-3.15-1.15-4.72-3.45-4.72-1.19,0-2.17.45-2.95,1.35-.77.89-1.16,2.01-1.16,3.37v8.46h-2.37v-14.83h2.37v2.46h.06c1.12-1.87,2.74-2.81,4.87-2.81,1.62,0,2.86.53,3.72,1.58.86,1.04,1.29,2.55,1.29,4.53v9.07Zm11.38-.14c-.56.31-1.3.46-2.22.46-2.6,0-3.9-1.45-3.9-4.34v-8.78h-2.55v-2.03h2.55v-3.62l2.37-.77v4.39h3.74v2.03h-3.74v8.36c0,.99.17,1.7.51,2.13s.9.64,1.68.64c.6,0,1.12-.16,1.55-.49v2.03Zm10.93-12.28c-.42-.32-1.01-.48-1.8-.48-1.01,0-1.86.48-2.55,1.43-.68.96-1.01,2.26-1.01,3.91v7.56h-2.37v-14.83h2.37v3.06h.06c.34-1.04.85-1.85,1.55-2.43.7-.59,1.47-.88,2.33-.88.62,0,1.09.07,1.42.2v2.46Zm14.41-2.4l-6.82,17.2c-1.22,3.07-2.93,4.61-5.13,4.61-.62,0-1.13-.06-1.55-.19v-2.13c.51.17.98.26,1.4.26,1.2,0,2.09-.71,2.69-2.14l1.19-2.81-5.79-14.8h2.64l4.01,11.41c.05.14.15.52.3,1.13h.09c.05-.23.14-.6.29-1.1l4.21-11.44h2.46Z" />
				<path d="m214.51,311.08v-20.77h5.91c1.8,0,3.22.44,4.27,1.32,1.05.88,1.58,2.02,1.58,3.43,0,1.18-.32,2.2-.96,3.07-.64.87-1.52,1.49-2.64,1.85v.06c1.4.16,2.52.7,3.36,1.59.84.89,1.26,2.05,1.26,3.48,0,1.78-.64,3.21-1.91,4.32s-2.88,1.65-4.82,1.65h-6.05Zm2.43-18.56v6.7h2.49c1.33,0,2.38-.32,3.14-.96.76-.65,1.14-1.55,1.14-2.72,0-2.02-1.33-3.03-3.98-3.03h-2.79Zm0,8.89v7.47h3.3c1.43,0,2.53-.34,3.32-1.01.79-.68,1.19-1.6,1.19-2.78,0-2.45-1.67-3.68-5.01-3.68h-2.79Zm26.14,2.85h-10.47c.04,1.65.48,2.93,1.33,3.82s2.02,1.35,3.5,1.35c1.67,0,3.21-.55,4.61-1.65v2.23c-1.3.95-3.03,1.42-5.17,1.42s-3.74-.67-4.94-2.01c-1.2-1.35-1.8-3.25-1.8-5.69,0-2.31.65-4.19,1.95-5.63,1.31-1.46,2.94-2.19,4.88-2.19s3.44.63,4.5,1.88c1.06,1.25,1.59,3,1.59,5.23v1.25Zm-2.43-2.01c0-1.37-.34-2.44-1-3.2-.65-.76-1.55-1.14-2.71-1.14s-2.07.4-2.85,1.2c-.78.8-1.26,1.85-1.45,3.14h8.01Zm18.66,8.83h-2.37v-2.52h-.06c-1.1,1.91-2.8,2.87-5.1,2.87-1.86,0-3.35-.66-4.47-1.98-1.11-1.33-1.67-3.14-1.67-5.43,0-2.45.62-4.42,1.85-5.89,1.24-1.48,2.88-2.22,4.94-2.22s3.52.8,4.45,2.4h.06v-9.18h2.37v21.95Zm-2.37-6.7v-2.19c0-1.2-.4-2.21-1.19-3.04-.79-.83-1.8-1.25-3.01-1.25-1.45,0-2.59.53-3.42,1.59-.83,1.06-1.25,2.53-1.25,4.4,0,1.71.4,3.06,1.19,4.05.8.98,1.87,1.48,3.21,1.48s2.39-.48,3.21-1.43c.83-.96,1.25-2.16,1.25-3.62Zm14.9-5.72c-.42-.32-1.01-.48-1.8-.48-1.01,0-1.86.48-2.55,1.43-.68.96-1.01,2.26-1.01,3.91v7.56h-2.37v-14.83h2.37v3.06h.06c.34-1.04.85-1.85,1.55-2.43.7-.59,1.47-.88,2.33-.88.62,0,1.09.07,1.42.2v2.46Zm8.76,12.77c-2.19,0-3.94-.69-5.26-2.07-1.3-1.39-1.95-3.23-1.95-5.52,0-2.49.68-4.44,2.04-5.84,1.36-1.4,3.2-2.1,5.52-2.1s3.93.68,5.17,2.04c1.25,1.36,1.87,3.25,1.87,5.66s-.67,4.26-2.01,5.69c-1.33,1.42-3.12,2.13-5.37,2.13Zm.17-13.53c-1.53,0-2.73.52-3.62,1.56-.89,1.03-1.33,2.46-1.33,4.29s.45,3.14,1.35,4.16c.9,1.01,2.1,1.52,3.61,1.52s2.71-.5,3.53-1.49c.83-.99,1.25-2.41,1.25-4.24s-.42-3.28-1.25-4.29c-.82-1-2-1.51-3.53-1.51Zm17.18,13.53c-2.19,0-3.94-.69-5.26-2.07-1.3-1.39-1.95-3.23-1.95-5.52,0-2.49.68-4.44,2.04-5.84,1.36-1.4,3.2-2.1,5.52-2.1s3.93.68,5.17,2.04c1.25,1.36,1.87,3.25,1.87,5.66s-.67,4.26-2.01,5.69c-1.33,1.42-3.12,2.13-5.37,2.13Zm.17-13.53c-1.53,0-2.73.52-3.62,1.56-.89,1.03-1.33,2.46-1.33,4.29s.45,3.14,1.35,4.16c.9,1.01,2.1,1.52,3.61,1.52s2.71-.5,3.53-1.49c.83-.99,1.25-2.41,1.25-4.24s-.42-3.28-1.25-4.29c-.82-1-2-1.51-3.53-1.51Zm32.04,13.18h-2.37v-8.51c0-1.64-.26-2.83-.77-3.56-.5-.73-1.35-1.1-2.55-1.1-1.01,0-1.88.46-2.59,1.39-.7.93-1.06,2.04-1.06,3.33v8.46h-2.37v-8.8c0-2.92-1.12-4.37-3.37-4.37-1.04,0-1.9.44-2.58,1.32-.68.87-1.01,2-1.01,3.4v8.46h-2.37v-14.83h2.37v2.35h.06c1.05-1.8,2.59-2.69,4.61-2.69,1.01,0,1.9.28,2.65.85.75.56,1.27,1.3,1.55,2.22,1.1-2.05,2.74-3.07,4.92-3.07,3.26,0,4.89,2.01,4.89,6.04v9.14Z" />
				<path d="m220.45,341.86h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.7.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Zm11.65,0h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.69.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Z" />
				<rect x="237.84" y="326.76" width="1.53" height="4.71" />
				<path d="m241.96,337.65c0-.4.06-.8.19-1.2.13-.41.31-.79.54-1.14.24-.35.53-.67.87-.96.35-.29.75-.52,1.19-.68-.65-.37-1.17-.83-1.56-1.4-.39-.58-.58-1.21-.58-1.91,0-.55.11-1.07.32-1.54.22-.47.52-.88.9-1.22.38-.34.83-.61,1.35-.8.52-.2,1.08-.29,1.68-.29s1.18.1,1.7.29c.52.2.97.47,1.35.81s.67.75.88,1.22c.21.47.32.98.32,1.53,0,.69-.19,1.33-.58,1.91-.39.57-.9,1.04-1.54,1.4.44.17.82.4,1.17.68s.63.61.86.96c.24.35.42.73.55,1.14.13.4.19.8.19,1.2,0,.66-.12,1.26-.36,1.81-.24.55-.58,1.02-1.01,1.41-.43.39-.94.69-1.55.91-.6.22-1.26.33-1.98.33s-1.37-.11-1.97-.33c-.6-.22-1.11-.52-1.55-.91-.44-.39-.78-.86-1.02-1.41-.24-.55-.36-1.15-.36-1.81Zm1.87-.15c0,.47.07.9.21,1.27.15.38.35.7.61.97.27.27.59.47.96.62.38.14.8.21,1.25.21s.85-.07,1.22-.22c.37-.15.69-.35.96-.62.27-.27.48-.59.63-.97.15-.38.23-.8.23-1.26,0-.42-.07-.81-.22-1.18-.14-.37-.34-.7-.61-.98-.27-.28-.59-.5-.96-.66-.37-.16-.79-.24-1.25-.24-.44,0-.84.08-1.21.23-.37.15-.68.36-.96.63-.27.27-.48.59-.63.97-.15.37-.23.78-.23,1.23Zm.54-7c0,.36.06.69.19,1,.13.3.31.57.54.8.23.22.5.4.8.54.3.13.62.19.97.19s.67-.07.97-.2c.31-.13.58-.31.8-.54.22-.23.4-.5.54-.8.13-.31.2-.64.2-.99s-.07-.7-.2-1.01c-.13-.31-.3-.58-.53-.8-.22-.22-.49-.4-.8-.53-.3-.13-.63-.2-.98-.2-.37,0-.71.07-1.02.2-.3.13-.57.32-.79.55-.22.22-.39.49-.51.8s-.18.64-.18.99Z" />
				<path d="m255.91,326.76v4.71h-1.53v-4.71h1.53Zm3.5,0v4.71h-1.53v-4.71h1.53Z" />
				<path d="m276.67,331.08l-3.62,5.45,3.56,5.33h-2.01l-2.12-3.5c-.13-.22-.29-.49-.47-.82h-.04c-.04.06-.2.34-.49.82l-2.16,3.5h-1.99l3.68-5.29-3.52-5.5h2.01l2.09,3.69c.15.27.31.55.45.84h.04l2.7-4.53h1.91Z" />
				<path d="m290.49,341.86h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.69.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Zm11.65,0h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.69.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Z" />
				<rect x="307.88" y="326.76" width="1.53" height="4.71" />
				<path d="m312,337.65c0-.4.06-.8.19-1.2.13-.41.31-.79.54-1.14.24-.35.53-.67.87-.96.35-.29.75-.52,1.19-.68-.65-.37-1.17-.83-1.56-1.4-.39-.58-.58-1.21-.58-1.91,0-.55.11-1.07.32-1.54.22-.47.52-.88.9-1.22.38-.34.83-.61,1.35-.8.52-.2,1.08-.29,1.68-.29s1.18.1,1.7.29c.52.2.97.47,1.35.81.38.34.67.75.88,1.22.21.47.32.98.32,1.53,0,.69-.19,1.33-.58,1.91-.39.57-.9,1.04-1.54,1.4.44.17.82.4,1.17.68s.63.61.86.96c.24.35.42.73.55,1.14.13.4.19.8.19,1.2,0,.66-.12,1.26-.36,1.81-.24.55-.58,1.02-1.01,1.41-.43.39-.94.69-1.55.91-.6.22-1.26.33-1.98.33s-1.37-.11-1.97-.33c-.6-.22-1.11-.52-1.55-.91-.44-.39-.78-.86-1.02-1.41-.24-.55-.36-1.15-.36-1.81Zm1.87-.15c0,.47.07.9.21,1.27.15.38.35.7.61.97.27.27.59.47.96.62.38.14.8.21,1.25.21s.85-.07,1.22-.22c.37-.15.69-.35.96-.62.27-.27.48-.59.63-.97.15-.38.23-.8.23-1.26,0-.42-.07-.81-.22-1.18-.14-.37-.34-.7-.61-.98-.27-.28-.59-.5-.96-.66s-.79-.24-1.25-.24c-.44,0-.84.08-1.21.23-.37.15-.68.36-.96.63-.27.27-.48.59-.63.97-.15.37-.23.78-.23,1.23Zm.54-7c0,.36.06.69.19,1,.13.3.31.57.54.8.23.22.5.4.8.54.3.13.62.19.97.19s.67-.07.97-.2c.31-.13.58-.31.8-.54.22-.23.4-.5.54-.8.13-.31.2-.64.2-.99s-.07-.7-.2-1.01c-.13-.31-.3-.58-.53-.8-.22-.22-.49-.4-.8-.53-.3-.13-.63-.2-.98-.2-.37,0-.71.07-1.02.2-.3.13-.57.32-.79.55-.22.22-.39.49-.51.8-.12.31-.18.64-.18.99Z" />
				<path d="m325.95,326.76v4.71h-1.53v-4.71h1.53Zm3.5,0v4.71h-1.53v-4.71h1.53Z" />
				<path d="m694.48,685.02h-3.39l-8.02-9.5c-.3-.36-.48-.6-.55-.72h-.06v10.22h-2.43v-20.77h2.43v9.76h.06c.14-.21.32-.45.55-.71l7.76-9.05h3.03l-8.91,9.96,9.53,10.8Zm3.63-18.59c-.42,0-.79-.14-1.09-.43s-.45-.66-.45-1.1.15-.81.45-1.1c.3-.3.66-.45,1.09-.45s.8.15,1.1.45c.31.29.46.66.46,1.1s-.15.79-.46,1.09c-.3.3-.67.45-1.1.45Zm1.16,18.59h-2.37v-14.83h2.37v14.83Zm11.66-.14c-.56.31-1.3.46-2.22.46-2.6,0-3.9-1.45-3.9-4.34v-8.78h-2.55v-2.03h2.55v-3.62l2.37-.77v4.39h3.74v2.03h-3.74v8.36c0,.99.17,1.7.51,2.13.34.42.9.64,1.68.64.6,0,1.12-.16,1.55-.49v2.03Zm13.26-.54c-1.14.69-2.49,1.03-4.05,1.03-2.11,0-3.82-.69-5.13-2.06-1.29-1.38-1.94-3.17-1.94-5.36,0-2.44.7-4.4,2.1-5.88,1.4-1.49,3.27-2.23,5.6-2.23,1.3,0,2.45.24,3.45.72v2.43c-1.1-.77-2.28-1.16-3.53-1.16-1.52,0-2.76.55-3.74,1.64-.97,1.08-1.45,2.51-1.45,4.27s.45,3.11,1.36,4.11c.92,1,2.14,1.51,3.68,1.51,1.29,0,2.51-.43,3.65-1.29v2.26Zm15.89.68h-2.37v-8.54c0-3.09-1.15-4.63-3.45-4.63-1.16,0-2.13.45-2.93,1.35-.79.89-1.19,2.03-1.19,3.43v8.4h-2.37v-21.95h2.37v9.59h.06c1.14-1.87,2.76-2.81,4.87-2.81,3.34,0,5.01,2.01,5.01,6.04v9.14Zm16.38-6.82h-10.47c.04,1.65.48,2.93,1.33,3.82.85.9,2.02,1.35,3.5,1.35,1.67,0,3.21-.55,4.61-1.65v2.23c-1.3.95-3.03,1.42-5.17,1.42s-3.74-.67-4.94-2.01c-1.2-1.35-1.8-3.25-1.8-5.69,0-2.31.65-4.19,1.96-5.63,1.31-1.46,2.94-2.19,4.88-2.19s3.44.63,4.5,1.88c1.06,1.25,1.59,3,1.59,5.23v1.25Zm-2.43-2.01c0-1.37-.34-2.44-1-3.2-.65-.76-1.55-1.14-2.71-1.14s-2.07.4-2.85,1.2-1.26,1.85-1.45,3.14h8.01Zm18.32,8.83h-2.37v-8.46c0-3.15-1.15-4.72-3.45-4.72-1.19,0-2.17.45-2.95,1.35-.77.89-1.16,2.01-1.16,3.37v8.46h-2.37v-14.83h2.37v2.46h.06c1.12-1.87,2.74-2.81,4.87-2.81,1.62,0,2.86.53,3.72,1.58.86,1.04,1.29,2.55,1.29,4.53v9.07Z" />
				<path d="m641.63,362.01h-10.77v-20.77h2.43v18.56h8.34v2.2Zm4.02-18.59c-.42,0-.79-.14-1.09-.43-.3-.29-.45-.66-.45-1.1s.15-.81.45-1.1c.3-.3.66-.45,1.09-.45s.8.15,1.1.45c.31.29.46.66.46,1.1s-.15.79-.46,1.09c-.3.3-.67.45-1.1.45Zm1.16,18.59h-2.37v-14.83h2.37v14.83Zm16.38-14.83l-5.91,14.83h-2.33l-5.62-14.83h2.61l3.77,10.77c.28.79.45,1.48.52,2.07h.06c.1-.74.25-1.41.46-2.01l3.94-10.83h2.51Zm3.69-3.77c-.42,0-.79-.14-1.09-.43-.3-.29-.45-.66-.45-1.1s.15-.81.45-1.1c.3-.3.66-.45,1.09-.45s.8.15,1.1.45c.31.29.46.66.46,1.1s-.15.79-.46,1.09c-.3.3-.67.45-1.1.45Zm1.16,18.59h-2.37v-14.83h2.37v14.83Zm17.03,0h-2.37v-8.46c0-3.15-1.15-4.72-3.45-4.72-1.19,0-2.17.45-2.95,1.35-.77.89-1.16,2.01-1.16,3.37v8.46h-2.37v-14.83h2.37v2.46h.06c1.12-1.87,2.74-2.81,4.87-2.81,1.62,0,2.86.53,3.72,1.58.86,1.04,1.29,2.55,1.29,4.53v9.07Zm17.06-1.19c0,5.44-2.61,8.17-7.82,8.17-1.83,0-3.44-.35-4.81-1.04v-2.37c1.67.93,3.26,1.39,4.78,1.39,3.65,0,5.47-1.94,5.47-5.82v-1.62h-.06c-1.13,1.89-2.83,2.84-5.1,2.84-1.84,0-3.33-.66-4.46-1.97-1.12-1.32-1.68-3.09-1.68-5.31,0-2.52.6-4.52,1.81-6.01,1.22-1.49,2.88-2.23,4.98-2.23s3.48.8,4.45,2.4h.06v-2.06h2.37v13.64Zm-2.37-5.52v-2.19c0-1.18-.4-2.19-1.2-3.03-.79-.84-1.78-1.26-2.97-1.26-1.47,0-2.62.54-3.45,1.61-.83,1.06-1.25,2.55-1.25,4.47,0,1.65.4,2.97,1.19,3.97.8.98,1.86,1.48,3.17,1.48s2.41-.47,3.24-1.42c.84-.95,1.26-2.16,1.26-3.63Z" />
				<path d="m730.58,362.01h-2.9l-3.48-5.82c-.32-.54-.63-1-.93-1.38-.3-.39-.61-.7-.93-.94-.31-.24-.65-.42-1.01-.52-.36-.12-.76-.17-1.22-.17h-2v8.83h-2.43v-20.77h6.2c.91,0,1.74.12,2.51.35.77.22,1.44.56,2,1.03.57.46,1.01,1.04,1.33,1.74.32.69.48,1.49.48,2.42,0,.72-.11,1.39-.33,2-.21.6-.52,1.13-.93,1.61-.4.47-.88.88-1.45,1.22-.56.33-1.19.58-1.9.77v.06c.35.15.65.33.9.54.26.19.51.42.74.7.23.27.46.58.68.93.23.34.49.73.77,1.19l3.9,6.24Zm-12.45-18.56v7.53h3.3c.61,0,1.17-.09,1.68-.28.52-.18.97-.44,1.35-.78.38-.35.67-.77.88-1.26.21-.5.32-1.06.32-1.68,0-1.11-.36-1.97-1.09-2.59-.71-.63-1.75-.94-3.11-.94h-3.33Zm21.11,18.91c-2.19,0-3.94-.69-5.26-2.07-1.3-1.39-1.95-3.23-1.95-5.52,0-2.49.68-4.44,2.04-5.84,1.36-1.4,3.2-2.1,5.52-2.1s3.93.68,5.17,2.04c1.25,1.36,1.87,3.25,1.87,5.66s-.67,4.26-2.01,5.69c-1.33,1.42-3.12,2.13-5.37,2.13Zm.17-13.53c-1.53,0-2.73.52-3.62,1.56-.89,1.03-1.33,2.46-1.33,4.29s.45,3.14,1.35,4.16c.9,1.01,2.1,1.52,3.61,1.52s2.71-.5,3.53-1.49c.83-.99,1.25-2.41,1.25-4.24s-.42-3.28-1.25-4.29c-.82-1-2-1.51-3.53-1.51Zm17.13,13.53c-2.19,0-3.94-.69-5.26-2.07-1.3-1.39-1.95-3.23-1.95-5.52,0-2.49.68-4.44,2.04-5.84,1.36-1.4,3.2-2.1,5.52-2.1s3.93.68,5.17,2.04c1.25,1.36,1.87,3.25,1.87,5.66s-.67,4.26-2.01,5.69c-1.33,1.42-3.12,2.13-5.37,2.13Zm.17-13.53c-1.53,0-2.73.52-3.62,1.56-.89,1.03-1.33,2.46-1.33,4.29s.45,3.14,1.35,4.16c.9,1.01,2.1,1.52,3.61,1.52s2.71-.5,3.53-1.49c.83-.99,1.25-2.41,1.25-4.24s-.42-3.28-1.25-4.29c-.82-1-2-1.51-3.53-1.51Zm31.99,13.18h-2.37v-8.51c0-1.64-.26-2.83-.77-3.56-.5-.73-1.35-1.1-2.55-1.1-1.01,0-1.88.46-2.59,1.39-.7.93-1.06,2.04-1.06,3.33v8.46h-2.37v-8.8c0-2.92-1.12-4.37-3.37-4.37-1.04,0-1.9.44-2.58,1.32-.68.87-1.01,2-1.01,3.4v8.46h-2.37v-14.83h2.37v2.35h.06c1.05-1.8,2.59-2.69,4.61-2.69,1.01,0,1.9.28,2.65.85.75.56,1.27,1.3,1.55,2.22,1.1-2.05,2.74-3.07,4.92-3.07,3.26,0,4.89,2.01,4.89,6.04v9.14Z" />
				<path d="m651.83,392.8h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.69.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Zm12.15-11.14c0-.46-.07-.87-.22-1.21-.14-.34-.34-.63-.59-.85-.25-.23-.54-.4-.87-.52-.34-.11-.7-.17-1.1-.17-.34,0-.67.05-.99.14-.32.09-.64.22-.95.38-.3.16-.6.35-.88.58-.28.22-.54.47-.79.75v-1.85c.48-.47,1.02-.83,1.62-1.07.6-.25,1.34-.38,2.2-.38.62,0,1.19.09,1.72.27.53.18.98.44,1.37.78.39.34.69.77.91,1.27.22.51.34,1.08.34,1.74,0,.6-.07,1.14-.21,1.62-.13.48-.34.94-.62,1.37-.27.43-.62.84-1.04,1.23-.42.39-.92.79-1.48,1.2-.71.51-1.3.94-1.76,1.3-.46.36-.82.69-1.1,1.01-.27.31-.46.62-.57.94-.11.31-.16.67-.16,1.07h7.52v1.55h-9.32v-.75c0-.65.07-1.21.21-1.71.14-.49.37-.96.7-1.4.32-.44.74-.88,1.26-1.33.53-.44,1.17-.94,1.93-1.5.55-.39,1-.77,1.37-1.13.37-.36.67-.72.9-1.07.22-.36.38-.72.47-1.08.1-.37.15-.77.15-1.18Z" />
				<rect x="669.22" y="377.7" width="1.53" height="4.71" />
				<path d="m680.02,392.8h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.69.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Zm14.77-7.61c0,1.26-.12,2.38-.35,3.36-.22.98-.55,1.8-.99,2.47-.43.67-.96,1.18-1.59,1.53-.62.34-1.34.52-2.14.52-.76,0-1.44-.16-2.03-.49-.59-.34-1.09-.82-1.5-1.46-.41-.64-.72-1.42-.93-2.35-.21-.93-.32-2-.32-3.2,0-1.32.11-2.49.33-3.5.22-1.01.55-1.86.98-2.54.43-.69.96-1.2,1.59-1.55.64-.35,1.37-.53,2.19-.53,3.17,0,4.75,2.58,4.75,7.74Zm-1.77.17c0-4.3-1.02-6.44-3.06-6.44-2.16,0-3.23,2.19-3.23,6.56,0,4.08,1.06,6.12,3.17,6.12s3.13-2.08,3.13-6.23Z" />
				<path d="m698.94,377.7v4.71h-1.53v-4.71h1.53Zm3.5,0v4.71h-1.53v-4.71h1.53Z" />
				<path d="m719.7,382.02l-3.62,5.45,3.56,5.33h-2.01l-2.12-3.5c-.13-.22-.29-.49-.47-.82h-.04c-.04.06-.2.34-.49.82l-2.16,3.5h-1.99l3.67-5.29-3.52-5.5h2.01l2.08,3.69c.15.27.31.55.45.84h.04l2.7-4.53h1.91Z" />
				<path d="m733.52,392.8h-1.73v-13.05c-.13.13-.33.29-.59.46-.25.17-.54.34-.86.51-.32.17-.65.33-1.01.47-.35.15-.69.26-1.03.35v-1.75c.38-.11.78-.25,1.2-.42.43-.18.85-.38,1.25-.6.41-.22.8-.46,1.17-.69.37-.25.68-.48.95-.72h.65v15.44Zm14.77-7.61c0,1.26-.12,2.38-.35,3.36-.22.98-.55,1.8-.99,2.47-.43.67-.96,1.18-1.59,1.53-.62.34-1.34.52-2.14.52-.76,0-1.44-.16-2.03-.49-.59-.34-1.09-.82-1.5-1.46-.41-.64-.72-1.42-.93-2.35-.21-.93-.32-2-.32-3.2,0-1.32.11-2.49.33-3.5.22-1.01.55-1.86.98-2.54.43-.69.96-1.2,1.59-1.55.64-.35,1.37-.53,2.19-.53,3.17,0,4.75,2.58,4.75,7.74Zm-1.77.17c0-4.3-1.02-6.44-3.06-6.44-2.16,0-3.23,2.19-3.23,6.56,0,4.08,1.06,6.12,3.17,6.12s3.13-2.08,3.13-6.23Z" />
				<rect x="750.91" y="377.7" width="1.53" height="4.71" />
				<path d="m764.12,388.52c0,.68-.13,1.3-.39,1.86-.25.55-.61,1.03-1.08,1.43-.46.39-1.02.7-1.67.92-.65.22-1.37.33-2.16.33-1.44,0-2.58-.27-3.43-.82v-1.85c1.02.8,2.18,1.2,3.5,1.2.53,0,1-.07,1.42-.2.43-.13.79-.33,1.1-.58.31-.25.54-.56.71-.92.17-.36.25-.76.25-1.21,0-1.97-1.4-2.96-4.21-2.96h-1.25v-1.46h1.19c2.49,0,3.73-.93,3.73-2.78,0-1.71-.95-2.57-2.84-2.57-1.07,0-2.07.36-3,1.07v-1.67c.96-.58,2.11-.86,3.43-.86.63,0,1.2.09,1.72.26.51.18.95.42,1.32.74s.65.69.84,1.14c.2.44.31.93.31,1.46,0,1.99-1,3.26-3.01,3.83v.04c.51.06.99.18,1.42.38.44.19.81.44,1.13.75.32.31.56.67.74,1.1.18.41.27.87.27,1.38Z" />
				<path d="m768.97,377.7v4.71h-1.53v-4.71h1.53Zm3.5,0v4.71h-1.53v-4.71h1.53Z" />
				<path d="m414.33,510l-3.47,12.27h-1.69l-2.52-8.97c-.11-.38-.17-.8-.2-1.25h-.03c-.03.42-.11.83-.22,1.23l-2.54,8.99h-1.67l-3.59-12.27h1.58l2.61,9.41c.11.39.18.8.21,1.23h.04c.03-.3.12-.71.27-1.23l2.71-9.41h1.38l2.6,9.48c.09.33.16.71.21,1.15h.03c.02-.3.1-.69.23-1.18l2.51-9.45h1.56Z" />
				<polygon points="421.49 510 415.6 524.31 414.29 524.31 420.16 510 421.49 510" />
				<path d="m422.92,522.27v-12.27h3.39c4.33,0,6.49,1.99,6.49,5.98,0,1.89-.6,3.42-1.81,4.57-1.2,1.15-2.8,1.72-4.82,1.72h-3.25Zm1.44-10.97v9.67h1.83c1.61,0,2.86-.43,3.76-1.29.9-.86,1.34-2.08,1.34-3.66,0-3.14-1.67-4.72-5.02-4.72h-1.92Z" />
			</g>
		</g>
	)
}

export default PlanQ
